// @module BTM.BRStickMainNavigation.StickyMainNavigation
define('BTM.BRStickMainNavigation.StickyMainNavigation.View'
,	[
		'btm_brstickmainnavigation_stickymainnavigation.tpl'
	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		btm_brstickmainnavigation_stickymainnavigation_tpl
	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class BTM.BRStickMainNavigation.StickyMainNavigation.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_brstickmainnavigation_stickymainnavigation_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service 
				(you'll need to deploy and activate the extension first)
			*/
			this.message = '';
			// var service_url = Utils.getAbsoluteUrl(getExtensionAssetsPath('services/StickyMainNavigation.Service.ss'));

			// jQuery.get(service_url)
			// .then((result) => {

			// 	this.message = result;
			// 	this.render();
			// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {
			
		}

		//@method getContext @return BTM.BRStickMainNavigation.StickyMainNavigation.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.BRStickMainNavigation.StickyMainNavigation.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
